import { Component, Vue } from "vue-property-decorator";
import { Actionsheet, Picker as VanPicker } from "vant";
import PickerManager from "@/shared/tools/pickerManager";
import { OptionItem } from "@/model/OptionItem";
import { PickerOptions } from "./types";

@Component
class Picker extends Vue {
  $refs!: {
    vanPicker: VanPicker & {
      setIndexes: (indexes: number[]) => void;
    };
  };

  private visible = false;

  private options: PickerOptions | null = null;

  public open(options: PickerOptions) {
    this.visible = true;
    this.options = {
      valueKey: "text",
      showToolbar: true,
      itemHeight: 44,
      manualClose: false,
      ...options,
    };

    this.$nextTick(() => {
      this.$refs.vanPicker.setIndexes([options.index || 0]);
    });
  }

  public close() {
    this.visible = false;
  }

  private render() {
    return this.options ? (
      <Actionsheet
        v-model={this.visible}
        closeOnClickOverlay={false} // 在弹窗中点击选择器的overlay会关闭弹窗，因此先禁止
      >
        <VanPicker
          ref="vanPicker"
          value-key={this.options.valueKey}
          show-toolbar={this.options.showToolbar}
          columns={this.options.columns}
          title={this.options.title}
          loading={this.options.loading}
          item-height={this.options.itemHeight}
          confirm-button-text={this.options.confirmButtonText}
          cancel-button-text={this.options.cancelButtonText}
          onCancel={this.onCancel}
          onConfirm={this.onConfirm}
        />
      </Actionsheet>
    ) : null;
  }

  private onCancel() {
    this.visible = false;

    if (this.options && this.options.onCancel) {
      this.options.onCancel();
    }
  }

  private onConfirm(value: OptionItem) {
    if (this.options) {
      if (!this.options.manualClose) {
        this.close();
      }

      this.options.onConfirm(value);
    }
  }
}

const instance = new Picker().$mount();
document.body.appendChild(instance.$el);
PickerManager.addPicker(instance);
export const picker = instance;
